import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UserVibe from './view';

class UserVibeContainer extends PureComponent {
  static defaultProps = {
    activeTab: null,
  };

  static propTypes = {
    activeTab: PropTypes.string,
  };

  render() {
    const { activeTab } = this.props;

    return <UserVibe activeTab={activeTab} />;
  }
}

export default connect((store, { match: { params: { activeTab } } }) => ({
  activeTab,
}))(UserVibeContainer);
